export const MachineStatusDescription = Object.freeze({
  Normal: 0,
  // 桌面资源繁忙，请联系在线客服
  Busy: 1,
  // 帐户余额不足
  Arrear: 2,
  // 可用时长不足
  InsufficientDuration: 3,
  // 创建桌面失败，请联系在线客服
  FailedAndContact: 4,
  // 桌面资源异常，请联系在线客服
  WeirdAndContact: 5,
  // 创建桌面失败，配额不足，请联系在线客服
  QuotaInsufficientAndContact: 6,
  // 账户余额不足自动释放
  ArrearAutoRelease: 7,
  // 套餐到期自动释放
  PackageExpiredAutoRelease: 8,
  // 检测到环境初始化时间较长
  EnvironmentInitLong: 9,
})
